module.exports = __webpack_public_path__ + "static/media/gryphon-house-living-dining-dark.553a77b0.jpg";